import { Checkbox, Fab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { Save } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { getEnvVariable } from '../../../../modules/environmentalList';
import { PostData } from '../../helpers/requests';
import { createRequest, requestApi } from '../../helpers/rest';
import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import DefaultSettings from '../settings';


// Create an array to store the selected rows

function LoadFromPrevPhase(props) {
    const [selectedRows, setSelectedRows] = useState([]);
    const [rows, setDataRows] = useState([]);
    const [companies, setCompanies] = useState([]);
    const params = useParams()
    console.log(props);
    const parentRecordVals = useSelector(state => state.sidebar && state.sidebar.modules);

    const handleCheckboxChange = (event, row) => {
        if (event.target.checked) {
            setSelectedRows((prevSelectedRows) => [...prevSelectedRows, row]);
        } else {
            setSelectedRows((prevSelectedRows) => prevSelectedRows.filter((selectedRow) => selectedRow !== row));
        }
    };

    useEffect(() => {
        // Your logic to load the data from the previous phase here
        if (parentRecordVals && parentRecordVals.PHASE_TYPES) {
            const getall = [
                {
                    url: getEnvVariable('Sidebar') + `/api/UtilityCompanies/${params.routeid1}/${parentRecordVals.PHASE_TYPES}/LoadFromLastPhase`,
                    type: 'get',

                },
                {
                    url: getEnvVariable('Sidebar') + `/api/UtilityCompanies/All/${params.routeid1}/${parentRecordVals.PHASE_TYPES}/CompaniesList`,
                    type: 'get',

                },
                // {
                //     url: getEnvVariable('MasterAdmin') + `/api/CompanyInternal/${parentRecordVals.CompanyId}/Users/All/Active`,
                //     type: 'get'
                // }
            ]
            Promise.all(getall.map(each => requestApi(createRequest(each, {}, null)).catch(error => { return error; }))).then(response => {
                console.log("Response", response);
                const [result, companiesResults] = response
                if (companiesResults) {
                    setCompanies(companiesResults)
                }
                if (result) {
                    setDataRows(result.data)
                    console.log(companies);
                }
            });
        }
    }, []);


    const handleSave = () => {
        // Your save logic here
        let url = getEnvVariable('Sidebar') + `/api/UtilityCompanies/${params.routeid1}/AddMultiple?${parentRecordVals.PHASE_TYPES}`;
        PostData(url, selectedRows, false, 'Previous Phase Saved Successfully').then((result) => {
            console.log(result);
            props.handleBack();
            // DefaultSettings.getAlert().show("No Required Fields are Available", 'success');
        });
    };


    return (
        <TableContainer>
            {rows.length === 0 ? (
                <div> No previous phase data available </div>
            ) : (
                <>
                    <Fab variant="contained" color="primary" className="float-end" size='small' onClick={handleSave}>
                        <Save />
                    </Fab>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Company Name</TableCell>
                                <TableCell>Usernames</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow key={row.Id}>
                                    <TableCell>
                                        <Checkbox
                                            checked={selectedRows.includes(row)}
                                            onChange={(event) => handleCheckboxChange(event, row)}
                                        />
                                    </TableCell>
                                    <TableCell>{companies && companies.find(each => each.Name == row.CompanyIdDesc).Name}</TableCell>
                                    <TableCell>{row.UtilityUserNamesDesc}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </>
            )}
        </TableContainer>
    );
}

export default LoadFromPrevPhase;
